import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <p>&copy; {currentYear} All rights reserved</p>
        </div>
        <div className="footer-right">
          <div className="connection-status">
            <span className="status-dot"></span>
            <span>Secured Connection</span>
            <svg className="signal-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M2 20h.01"></path>
              <path d="M7 20v-4"></path>
              <path d="M12 20v-8"></path>
              <path d="M17 20v-12"></path>
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 